import script from "./VehicleListingsRecentPriceDrops.vue?vue&type=script&lang=js"
export * from "./VehicleListingsRecentPriceDrops.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__